import { createSlice } from "@reduxjs/toolkit";

const initialCoinCategoriesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  uploadimage: [], 
  imageField: [], 
  newCoinCategory: [], 
  editCoinCategory: [], 
  deletedCoinCategory: [], 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AddCoinFormSlice = createSlice({

  name: "AddCoinForm",
  initialState: initialCoinCategoriesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    CoinCategoriesList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    CoinCategoriesExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    uploadImage: (state, action) => {
      const { uploadimage, imageField} = action.payload;
      state.error = null;
      state.uploadimage = uploadimage;
      state.imageField = imageField;
    },
    createCoinCategory: (state, action) => {
      const { newCoinCategory } = action.payload;
      state.error = null;
      state.newCoinCategory = newCoinCategory;
    },
    updateCoinCategory: (state, action) => {
      const { editCoinCategory } = action.payload;
      state.error = null;
      state.editCoinCategory = editCoinCategory;
    },
    deleteCoinCategory: (state, action) => {
      const { deletedCoinCategory } = action.payload;
      state.error = null;
      state.deletedCoinCategory = deletedCoinCategory;
    },
  }
});
